import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/900.css';

import { theme } from './theme';
import Layout from './components/Layout/Layout';
import Dashboard from './pages/Dashboard/Dashboard';
import CampaignManagement from './pages/CampaignManagement/CampaignManagement';
import ContentCreation from './pages/ContentCreation/ContentCreation';
import UserManagement from './pages/UserManagement/UserManagement';
import Analytics from './pages/Analytics/Analytics';
import MediaServices from './pages/MediaServices/MediaServices';
import LandingPage from './pages/MediaServices/LandingPage';
import Articles from './pages/MediaServices/Articles';
import ReportEditor from './pages/Reports/ReportEditor';
import CalendarPlanning from './pages/CalendarPlanning/CalendarPlanning';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService/TermsOfService';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Router>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Dashboard />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="campaigns" element={<CampaignManagement />} />
              <Route path="content" element={<ContentCreation />} />
              <Route path="users" element={<UserManagement />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="media-services" element={<MediaServices />} />
              <Route path="werbemittel/landing" element={<LandingPage />} />
              <Route path="werbemittel/artikel" element={<Articles />} />
              <Route path="calendar" element={<CalendarPlanning />} />
              <Route path="reports" element={<ReportEditor />} />
              <Route path="privacy-policy" element={<PrivacyPolicy />} />
              <Route path="terms-of-service" element={<TermsOfService />} />
            </Route>
          </Routes>
        </Router>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
